import { ref } from 'vue'
import i18n from '@repo/i18n/common'
import {
  DEFAULT_APP_LOCALE,
  getAppLocale,
  LANDING_LOCALE_STORAGE_KEY,
  reconcileLocaleStorage,
  setAppLocale,
  toVueI18nKey,
  type AppLocale,
} from '@repo/common-utils/utils/appLocale'
import { landingMessages } from '@/locales/landingMessages'

export const LOCALE_KEY = LANDING_LOCALE_STORAGE_KEY

export type LandingLocale = AppLocale

function syncVueI18n(l: LandingLocale) {
  const mapped = toVueI18nKey(l)
  if (i18n.global.locale.value !== mapped) {
    i18n.global.locale.value = mapped
  }
}

/** 与 getAppLocale 同步，供模板响应式使用 */
export const locale = ref<LandingLocale>(DEFAULT_APP_LOCALE)

export function initLandingLocale(): void {
  reconcileLocaleStorage()
  const detected = getAppLocale()
  locale.value = detected
  setAppLocale(detected)
  syncVueI18n(detected)
}

export const localeLabels: Record<LandingLocale, string> = {
  en: 'EN',
  'zh-CN': '简',
  'zh-TW': '繁',
}

export const localeNames: Record<LandingLocale, string> = {
  en: 'English',
  'zh-CN': '简体中文',
  'zh-TW': '繁體中文',
}

/** 唯一 UI 切换入口：写入 SSOT 并同步 vue-i18n */
export function setLocale(l: LandingLocale) {
  setAppLocale(l)
  locale.value = getAppLocale()
  syncVueI18n(locale.value)
}

export function t(key: string): string {
  const val = landingMessages[locale.value]?.[key]
  if (Array.isArray(val)) return val[0]
  return (val as string) ?? key
}

export function ta(key: string): string[] {
  const val = landingMessages[locale.value]?.[key]
  return Array.isArray(val) ? val : [val as string]
}

export function useLandingLocale() {
  return {
    locale,
    setLocale,
    localeLabels,
    localeNames,
    t,
    ta,
  }
}
